
import list from "./list"
import show from "./show"
import create from "./create"
import update from "./update"
import del from "./del"
export default  {
    namespaced:true,
    modules:{
        list,
        show,
        create,
        del,
        update,
    }
}